import React from 'react'
import { PickValueDialog } from './common/pickValueDialog'
import context from '@/context'

function JobTitleDialog (props) {
  return <PickValueDialog
    {...props}
    title='JobPosition.JobPositionTitle'
    dataSource={(request) => context.api.jobPositionService.getOrganizationUnitJobsLookup(props.organizationalUnitId, request)} />
}

export default {
  component: JobTitleDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/jobTitle.js